import React from 'react';
import { makeLazyLoader, moduleLoader } from '@deriv/shared';
import { observer } from '@deriv/stores';
import classNames from 'classnames';

const HeaderFallback = () => {
    return <div className={classNames('header')} />;
};

const HeaderLegacy = makeLazyLoader(
    () => moduleLoader(() => import(/* webpackChunkName: "dtrader-header" */ './header-legacy')),
    () => <HeaderFallback />
)();

const Header = observer(() => {
    // Hide header when embedded as iframe — parent app provides its own UI chrome
    if (window !== window.top) {
        // eslint-disable-next-line no-console
        console.log('DTrader running in iframe — header hidden (header.tsx)');
        return null;
    }
    return <HeaderLegacy />;
});

export default Header;
